import { render, staticRenderFns } from "./addressLocationItem.vue?vue&type=template&id=7363c833&scoped=true&"
import script from "./addressLocationItem.vue?vue&type=script&lang=ts&"
export * from "./addressLocationItem.vue?vue&type=script&lang=ts&"
import style0 from "./addressLocationItem.vue?vue&type=style&index=0&id=7363c833&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7363c833",
  null
  
)

export default component.exports